<div class="widget-area">
  <div class="widget-archives footer-widget mb-50">
    <h3 class="widget-title">Academics</h3>
    <ul>
      <li class="menu-item-has-children" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
        <ul class="sub-menu">
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/academics/disciplines-and-departments">Disciplines &amp; Departments</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/academics/courses-offered-and-admissions">Courses Offered &amp; Admissions</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/academics/college-fee">College Fee</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/academics/scholarships">Scholarships</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/academics/financial-aid">Financial Aid</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/academics/curriculum">Curriculum</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/academics/academic-calender">Academic Calender</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/academics/quality-parameters">Quality Parameters</a></li>
          <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"><a routerLink="/academics/any-others">Any Others</a></li>
        </ul>
      </li>
    </ul>
  </div>
</div>
